<template>
  <div
    class="auth-wrapper pr-15 pl-15"
    :style="{
      backgroundImage: 'url(' + $store.getters[`customization/loginBg`] + ')'
    }"
  >
    <div class="language">
      <LanguageBar />
    </div>
    <b-row class="register-form">
      <b-col class="register-content-col">
        <img class="logo-image" :src="$store.getters[`customization/logo`]" />
        <div class="register-content">
          <div class="title">{{ $t('text.create_an_organisation') }}</div>
          <OrganisationInformation ref="organisationInformation" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LanguageBar from '@/components/LanguageBar.vue'
import OrganisationInformation from '@/components/register/OrganisationInformation.vue'
import '@/assets/font/font.css'
import '@/assets/css/login.scss'
import '@/assets/css/global.scss'
export default {
  name: 'register',
  components: {
    LanguageBar,
    OrganisationInformation
  }
}
</script>
